export default __webpack_public_path__ + "static/bg_2-21ed6a908db7141f7b9940eb5de90d56.png";